var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.265 28.75C12.5 28.75 12.5 18.75 12.5 18.75H8.75L14.9738 13.75L21.25 18.75H17.5C17.5 18.75 16.485 26.3675 22.265 28.75ZM24.3488 10.115C24.0837 5.17625 20.0075 1.25 15 1.25C9.9925 1.25 5.91625 5.17625 5.65125 10.115C2.43875 10.6938 0 13.4975 0 16.875C0 20.6712 3.07875 23.75 6.875 23.75H11.0025C10.6587 22.8538 10.4275 21.995 10.28 21.25H6.875C4.4625 21.25 2.5 19.2875 2.5 16.875C2.5 13.3787 5.59875 12.0837 8.04125 12.225C7.8325 6.9525 10.8013 3.75 15 3.75C19.3162 3.75 22.3637 7.24625 21.9587 12.225C24.14 12.1675 27.5 13.1637 27.5 16.875C27.5 19.2875 25.5375 21.25 23.125 21.25H19.9775C20.055 22.025 20.24 22.9112 20.6013 23.75H23.125C26.9212 23.75 30 20.6712 30 16.875C30 13.4975 27.5613 10.6938 24.3488 10.115Z",
    fill: "var(--color-secondary)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4acebf26.svg";
export { ForwardRef as ReactComponent };